import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TypedValue from '../TypedValue';

const ValueVersusValue = ({ a, text, aColour, bColour, b = null, type = 'number', accuracy = 0 }) => {
    const theme = useTheme();

    return (
        <Stack spacing={0} sx={{ textAlign: 'center' }}>
            <Box>
                <Typography
                    variant="h5"
                    sx={{ display: 'inline', lineHeight: 1, color: aColour }}
                >
                    <TypedValue value={a} type={type} accuracy={accuracy} />
                </Typography>
                {b !== null && (
                    <>
                        <Typography variant="body1" color={theme.palette.text.secondary} sx={{ display: 'inline', lineHeight: 1 }}> vs </Typography>
                        <Typography
                            variant="h5"
                            sx={{ display: 'inline', lineHeight: 1, color: bColour }}
                        >
                            <TypedValue value={b} type={type} accuracy={accuracy} />
                        </Typography>
                    </>
                )}
            </Box>
            <Typography variant="body2" color={theme.palette.text.secondary}>{text}</Typography>
        </Stack>
    );
};

export default ValueVersusValue;